<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
:root {
  color-scheme: light;
  --bg: #f5f3ef;
  --panel: #ffffff;
  --sidebar: #171411;
  --sidebar-soft: #231f1a;
  --text: #171411;
  --muted: #7b746d;
  --line: rgba(23, 20, 17, 0.08);
  --accent: #b78b5f;
}

* {
  box-sizing: border-box;
}

html,
body,
#app {
  min-height: 100%;
}

body {
  margin: 0;
  font-family: "Helvetica Neue", Arial, sans-serif;
  background: var(--bg);
  color: var(--text);
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

a {
  color: inherit;
  text-decoration: none;
}
</style>
